"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamePage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const context_1 = require("@lit/context");
const app_main_1 = require("../layout/app-main");
const regex = /attack(.*)/i;
let GamePage = (() => {
    var _GamePage_anchorClient_accessor_storage, _GamePage_playerInfo_accessor_storage, _GamePage_allPlayerCreatures_accessor_storage, _GamePage_messageBox_accessor_storage;
    let _classDecorators = [(0, decorators_js_1.customElement)("game-page")];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = lit_1.LitElement;
    let _instanceExtraInitializers = [];
    let _anchorClient_decorators;
    let _anchorClient_initializers = [];
    let _playerInfo_decorators;
    let _playerInfo_initializers = [];
    let _allPlayerCreatures_decorators;
    let _allPlayerCreatures_initializers = [];
    let _messageBox_decorators;
    let _messageBox_initializers = [];
    var GamePage = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _GamePage_anchorClient_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _anchorClient_initializers, null)));
            _GamePage_playerInfo_accessor_storage.set(this, __runInitializers(this, _playerInfo_initializers, null));
            _GamePage_allPlayerCreatures_accessor_storage.set(this, __runInitializers(this, _allPlayerCreatures_initializers, null));
            _GamePage_messageBox_accessor_storage.set(this, __runInitializers(this, _messageBox_initializers, void 0));
        }
        get anchorClient() { return __classPrivateFieldGet(this, _GamePage_anchorClient_accessor_storage, "f"); }
        set anchorClient(value) { __classPrivateFieldSet(this, _GamePage_anchorClient_accessor_storage, value, "f"); }
        get playerInfo() { return __classPrivateFieldGet(this, _GamePage_playerInfo_accessor_storage, "f"); }
        set playerInfo(value) { __classPrivateFieldSet(this, _GamePage_playerInfo_accessor_storage, value, "f"); }
        get allPlayerCreatures() { return __classPrivateFieldGet(this, _GamePage_allPlayerCreatures_accessor_storage, "f"); }
        set allPlayerCreatures(value) { __classPrivateFieldSet(this, _GamePage_allPlayerCreatures_accessor_storage, value, "f"); }
        get messageBox() { return __classPrivateFieldGet(this, _GamePage_messageBox_accessor_storage, "f"); }
        set messageBox(value) { __classPrivateFieldSet(this, _GamePage_messageBox_accessor_storage, value, "f"); }
        onMessage(e) {
            return __awaiter(this, void 0, void 0, function* () {
                const { author, body } = e.detail;
                this.messageBox.addMessage({
                    body: body,
                    author: author,
                });
                // HARD CODED ATTACK
                if (this.allPlayerCreatures) {
                    const match = body.match(regex);
                    if (match && match[1]) {
                        const target = match[1].trim().toLowerCase();
                        console.log(`You attacked ${target}`);
                        // find the target
                        this.allPlayerCreatures.forEach(([targetPda, creature]) => __awaiter(this, void 0, void 0, function* () {
                            if (this.anchorClient &&
                                this.playerInfo &&
                                creature.name.toLowerCase() === target) {
                                console.log(`FOUND TARGET ${targetPda}`);
                                this.messageBox.addMessage({
                                    body: `You swing at ${target}`,
                                    author: "",
                                });
                                yield this.anchorClient.attackCreature(this.playerInfo.creaturePda, targetPda);
                                this.messageBox.addMessage({
                                    body: `${target} looks hurt`,
                                    author: "",
                                });
                                // fetch everyone again
                                yield this.fetchPlayer();
                                yield this.fetchAllPlayerCreatures();
                            }
                        }));
                    }
                }
            });
        }
        fetchPlayer() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.anchorClient) {
                    this.playerInfo = yield this.anchorClient.getPlayerInfo();
                }
            });
        }
        willUpdate(changedProperties) {
            return __awaiter(this, void 0, void 0, function* () {
                if (changedProperties.has("anchorClient")) {
                    yield this.fetchPlayer();
                    yield this.fetchAllPlayerCreatures();
                }
            });
        }
        fetchAllPlayerCreatures() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.anchorClient) {
                    this.allPlayerCreatures =
                        yield this.anchorClient.getAllPlayerCreaturesLoggedIn();
                }
            });
        }
        getPlayerList() {
            if (this.allPlayerCreatures) {
                return (0, lit_1.html) `
        <sl-menu class="menu-value" style="width: 300px;">
          ${this.allPlayerCreatures.map(([pda, creature]) => {
                    return (0, lit_1.html) `<sl-menu-item
              >${creature.name} (hp: ${creature.hp}/${creature.maxHp}, lvl:
              ${creature.level})</sl-menu-item
            >`;
                })}
        </sl-menu>
      `;
            }
            else {
                return (0, lit_1.html) `
        <sl-menu class="menu-value" style="width: 300px;">
          <sl-menu-item value="opt-1">No one is here</sl-menu-item>
        </sl-menu>
      `;
            }
        }
        render() {
            var _a, _b, _c, _d, _e, _f;
            return (0, lit_1.html) `
      <h1>Game Page</h1>

      <img src="${(_a = this.playerInfo) === null || _a === void 0 ? void 0 : _a.portrait}" class="portrait" />
      <p>
        hp: ${(_b = this.playerInfo) === null || _b === void 0 ? void 0 : _b.creature.hp}/${(_c = this.playerInfo) === null || _c === void 0 ? void 0 : _c.creature.maxHp}
      </p>
      <p>
        mp: ${(_d = this.playerInfo) === null || _d === void 0 ? void 0 : _d.creature.mp}/${(_e = this.playerInfo) === null || _e === void 0 ? void 0 : _e.creature.maxMp}
      </p>
      <p>lvl: ${(_f = this.playerInfo) === null || _f === void 0 ? void 0 : _f.creature.level}</p>

      <p class="tutorial">
        Tutorial:
        <br />
        - You can attack a player by typing "attack [player_name]"
        <br />
        - You gain a level when you kill a player
        <br />
        - Immediatelty respawn when you die
      </p>

      <div class="container">
        <div class="main-content">
          <message-box
            @on-message="${this.onMessage}"
            id="message-box"
          ></message-box>
        </div>
        ${this.getPlayerList()}
      </div>
    `;
        }
    };
    _GamePage_anchorClient_accessor_storage = new WeakMap();
    _GamePage_playerInfo_accessor_storage = new WeakMap();
    _GamePage_allPlayerCreatures_accessor_storage = new WeakMap();
    _GamePage_messageBox_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "GamePage");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _anchorClient_decorators = [(0, context_1.consume)({ context: app_main_1.anchorClientContext, subscribe: true }), (0, decorators_js_1.state)()];
        _playerInfo_decorators = [(0, decorators_js_1.state)()];
        _allPlayerCreatures_decorators = [(0, decorators_js_1.state)()];
        _messageBox_decorators = [(0, decorators_js_1.query)("#message-box")];
        __esDecorate(_classThis, null, _anchorClient_decorators, { kind: "accessor", name: "anchorClient", static: false, private: false, access: { has: obj => "anchorClient" in obj, get: obj => obj.anchorClient, set: (obj, value) => { obj.anchorClient = value; } }, metadata: _metadata }, _anchorClient_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _playerInfo_decorators, { kind: "accessor", name: "playerInfo", static: false, private: false, access: { has: obj => "playerInfo" in obj, get: obj => obj.playerInfo, set: (obj, value) => { obj.playerInfo = value; } }, metadata: _metadata }, _playerInfo_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _allPlayerCreatures_decorators, { kind: "accessor", name: "allPlayerCreatures", static: false, private: false, access: { has: obj => "allPlayerCreatures" in obj, get: obj => obj.allPlayerCreatures, set: (obj, value) => { obj.allPlayerCreatures = value; } }, metadata: _metadata }, _allPlayerCreatures_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _messageBox_decorators, { kind: "accessor", name: "messageBox", static: false, private: false, access: { has: obj => "messageBox" in obj, get: obj => obj.messageBox, set: (obj, value) => { obj.messageBox = value; } }, metadata: _metadata }, _messageBox_initializers, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        GamePage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = (0, lit_1.css) `
    .container {
      display: flex;
      height: 100vh;
    }
    .portrait {
      height: 150px;
      padding: 5px;
    }
    .main-content {
      flex: 1;
      padding: 10px;
    }
    .right-menu {
      width: 200px;
      padding: 10px;
    }
    .tutorial {
      color: green;
    }
  `;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return GamePage = _classThis;
})();
exports.GamePage = GamePage;
